import Vue from 'vue'
import { isDataplatform } from '@/shared/Config'
import { createRouter, createWebHashHistory } from 'vue-router'
import RouteWrapper from '@/shared/RouteWrapper'
import rawRoutes from './routes'

const routes = rawRoutes.map(r => {
  const route = { ...r }
  const { path } = route
  route.path = ''
  return {
    path: path,
    component: RouteWrapper,
    children: [
      route
    ]
  }
})

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta?.legacy && isDataplatform()) return next('/home')
  next()
})

Vue.$router = router

export default router
